import { SelectedValueReportingFacet } from '../../../graphql/schema/types/value-reporting'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ratingsRequest } from './requests/ratings-request'

export const useRatings = ({
  organizationUuid,
  selectedFacets,
  enabled
}: {
  organizationUuid: string
  selectedFacets: SelectedValueReportingFacet[]
  enabled: boolean
}) => {
  const { data, isLoading, isError, error } = useContrastQuery(
    [Query.VR_RATINGS, organizationUuid, selectedFacets],
    ratingsRequest,
    {
      organizationUuid,
      selectedFacets
    },
    {
      enabled
    }
  )

  if (isError) {
    throw new Error(`useRatings has encountered an error: ${error?.message}`)
  }

  return {
    isLoading,
    ...data
  }
}
